import { render } from "./WordCloudComponent.vue?vue&type=template&id=63e929cd&scoped=true"
import script from "./WordCloudComponent.vue?vue&type=script&lang=js"
export * from "./WordCloudComponent.vue?vue&type=script&lang=js"

import "./WordCloudComponent.vue?vue&type=style&index=0&id=63e929cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e929cd"]])

export default __exports__